module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "upload-facial-detail-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("人脸导入记录详情\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "top-container"
  }, [_c('div', {
    staticClass: "success-content"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icon/icon_check_blue.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s('上传成功数量：' + (_vm.dataInfo.correctLine || '0') + '张'))])]), _vm._v(" "), _c('div', {
    staticClass: "failure-content"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icon/icon_cancel_red.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s('上传失败数量：' + (_vm.dataInfo.incorrectLine || '0') + '张'))])]), _vm._v(" "), _c('el-button', {
    staticClass: "button-export",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickDownload
    }
  }, [_vm._v("导出失败原因")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailData.length > 0),
      expression: "detailData.length > 0"
    }],
    attrs: {
      "data": _vm.detailData
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "学号",
      "prop": "studentCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "姓名",
      "prop": "studentName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "错误信息",
      "prop": "incorrectReason"
    }
  })], 1)], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "current-page": _vm.pageNum
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-746f35eb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserManage/UserManage/UploadFacialDetail.vue
// module id = 1075
// module chunks = 0